import { Row, Col, Card, Button, Tabs } from "antd";
import "./index.css";

import BannerSlider from "./BannerSlider";
import SimpulJaringan from "./SimpulJaringan";
import KatalogMetadata from "./KatalogMetadata";

const App = () => {
  const items = [
    {
      label: `Selamat Datang`,
      key: 0,
      children: <BannerSlider />,
    },
    {
      label: `Simpul Jaringan`,
      key: 1,
      children: <SimpulJaringan />,
      disabled: true,
    },
    {
      label: `Katalog Metadata`,
      key: 2,
      children: <KatalogMetadata />,
      disabled: true,
    },
  ];

  return (
    <div style={{ background: "#ececec", padding: "14px", height: "100%" }}>
      <Row justify="center" align="middle" style={{ height: "100%" }}>
        <Col
          style={{
            padding: "0px 14px",
          }}
        >
          <Tabs defaultActiveKey="0" type="card" items={items} />
        </Col>
      </Row>
    </div>
  );
};
export default App;
